import React from 'react';
import { Button } from 'src/shared/components/ui/button';
import { Progress } from 'src/shared/components/ui/progress';
import { type BulkRun, countOf, failuresOf } from '../bulkRun';

type BulkRunSummaryProps = {
    run: BulkRun;
    onStop: () => void;
};

const statusText = (run: BulkRun) => {
    if (run.status === 'running') {
        return `Onboarding ${run.outcomes.size} of ${run.customers.length}`;
    } else if (run.status === 'stopped') {
        return 'Onboarding stopped';
    } else {
        return 'Onboarding finished';
    }
};

const BulkRunSummary = ({ run, onStop }: BulkRunSummaryProps) => {
    const failures = failuresOf(run);

    return (
        <section aria-label='Bulk onboarding' className='flex flex-col gap-2'>
            <p>{statusText(run)}</p>
            <div className='flex items-center gap-4'>
                <Progress
                    aria-label='Onboarding progress'
                    value={Math.round((run.outcomes.size / run.customers.length) * 100)}
                    className='h-2 flex-1'
                />
                <Button variant='outline' size='sm' disabled={run.status !== 'running'} onClick={onStop}>
                    Stop
                </Button>
            </div>
            <dl className='grid grid-cols-[max-content_max-content] gap-x-6'>
                <dt>Onboarded</dt>
                <dd>{countOf(run, 'created')}</dd>
                <dt>Already in Sunrise</dt>
                <dd>{countOf(run, 'active')}</dd>
                <dt>Archived in Sunrise</dt>
                <dd>{countOf(run, 'archived')}</dd>
                <dt>Failed</dt>
                <dd>{countOf(run, 'failed')}</dd>
            </dl>
            {failures.length > 0 && (
                <ul aria-label='Failed customers'>
                    {failures.map(({ customer, reason }) => (
                        <li key={customer.customerId}>
                            {customer.customerId} {reason}
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
};

export default BulkRunSummary;
